/**
 * generic upload class
 */
export class Upload {
  name: String;
  path: string;
  file: any;
}



// WEBPACK FOOTER //
// D:/AppDev/meetup/kla-firebase-poker/web/src/app/class/upload.ts